import { render } from "./PatientApprove.vue?vue&type=template&id=71c61903&scoped=true"
import script from "./PatientApprove.vue?vue&type=script&lang=js"
export * from "./PatientApprove.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71c61903"]])

export default __exports__